<template>
  <v-card width="334" flat class="gift-card-barcode primary-font" height="126">
    <p class="barcode-title">{{ item.name }}: {{ giftCardAmount }}</p>
    <barcode class="barcode" :value="item.barcode" width="5" fontSize="40">
    </barcode>
  </v-card>
</template>
<script>
import Barcode from "vue-barcode";
export default {
  name: "GiftCardBarcode",
  components: {
    Barcode,
  },
  props: {
    item: {
      type: Object,
      default: false,
    },
  },
  computed: {
    giftCardAmount() {
      if (this.item.restAmount == this.item.originalAmount) {
        return "Kr " + this.formatAmount(this.item.originalAmount, 2);
      } else {
        return (
          "Kr " +
          this.formatAmount(this.item.restAmount, 1) +
          " (av " +
          this.formatAmount(this.item.originalAmount, 2) +
          ")"
        );
      }
    },
  },
  methods: {
    formatAmount(value, format) {
      if (value % 1 == 0 && format == 1) {
        return value + ", –";
      } else if (value % 1 == 0 && format == 2) {
        return value;
      } else {
        return value.toFixed(2).replace(".", ",");
      }
    },
  },
};
</script>
<style lang="scss">
.gift-card-barcode {
  &.fixit-design {
    color: var(--v-primary-base) !important;
    border-color: var(--v-secondary-base) !important;
    .barcode-title {
      color: var(--v-primary-base);
    }
  }
  &.salon-design {
    color: var(--v-primary-base) !important;
    border-color: var(--v-primary-base) !important;
    .barcode-title {
      color: black !important;
    }
  }
  border: 2px solid !important;
  border-radius: 12px !important;
  .barcode-title {
    margin: 10px 10px 8px 10px;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    text-align: center;
  }
  .barcode {
    .vue-barcode-element {
      height: 68px !important;
      max-width: 314px !important;
    }
  }
}
</style>
